import React, { PureComponent } from 'react';
import { Modal, Form } from 'antd';
import PropTypes from 'prop-types';
import text from './ClientList.page.translation';
import AddClientForm from './AddClient.form';
import './ClientList.style.less';

const AddClientFormBuilder = Form.create()(AddClientForm);

class AddClientModal extends PureComponent {
  renderTitle = () => {
    const {
      intl: { formatMessage },
    } = this.props;
    return (
      <div>
        <div className="title-container">
          {formatMessage(text.modalAdd.title)}
        </div>
        <div className="modal-separator" />
      </div>
    );
  };

  renderBody = () => {
    const { handleCancel, handleSuccess, createNewClientLoading } = this.props;

    return (
      <div className="body-container">
        <AddClientFormBuilder
          intl={this.props.intl}
          formCancel={handleCancel}
          onSubmitForm={handleSuccess}
          createNewClientLoading={createNewClientLoading}
        />
      </div>
    );
  };

  render() {
    const { handleCancel } = this.props;

    return (
      <Modal
        className="delivery-add-client-modal"
        bodyStyle={{ padding: '0px' }}
        centered
        title=""
        visible={this.props.visible}
        footer={null}
        onCancel={handleCancel}
        destroyOnClose
      >
        {this.renderTitle()}
        {this.renderBody()}
      </Modal>
    );
  }
}

AddClientModal.propTypes = {
  visible: PropTypes.bool,
  intl: PropTypes.object,
  handleCancel: PropTypes.func,
  handleSuccess: PropTypes.func,
  createNewClientLoading: PropTypes.bool,
};

export default AddClientModal;
